var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4835 0C7.3755 0 0 7.392 0 16.5C0 25.608 7.3755 33 16.4835 33C25.608 33 33 25.608 33 16.5C33 7.392 25.608 0 16.4835 0ZM16.5 29.7C9.207 29.7 3.3 23.793 3.3 16.5C3.3 9.207 9.207 3.3 16.5 3.3C23.793 3.3 29.7 9.207 29.7 16.5C29.7 23.793 23.793 29.7 16.5 29.7ZM16.137 8.25H16.038C15.378 8.25 14.85 8.778 14.85 9.438V17.226C14.85 17.8035 15.147 18.348 15.6585 18.645L22.506 22.7535C23.067 23.0835 23.793 22.9185 24.123 22.3575C24.4695 21.7965 24.288 21.054 23.7105 20.724L17.325 16.929V9.438C17.325 8.778 16.797 8.25 16.137 8.25Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.95908434661d2cccf9ba3bb9f4f0ae72.svg";
export { ForwardRef as ReactComponent };